import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {PUT_COORDINATOR_APPEAL_SAVE_UPDATE_SUBJECT_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface SaveUpdateSubjectRequest {
  examYear: number;
  examCode: string;
  examSeriesCode: string;
  subjectCodes: string[];
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutCoordinatorAppealSaveUpdateSubject = ({uuid, onSuccess, onError}: Input) => {
  const putCoordinatorAppealSaveUpdateSubject = async (reqBody: SaveUpdateSubjectRequest) => {
    await axiosClient.put<void>(PUT_COORDINATOR_APPEAL_SAVE_UPDATE_SUBJECT_URL(uuid), reqBody);
  };

  return useCustomMutation(putCoordinatorAppealSaveUpdateSubject, {
    onSuccess,
    onError,
  });
};
